import React from "react";
import styles from "./styles.module.css";
const ExpiryContent = ({ timeLeft }) => {
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };
  return (
    <div>
      <p className={styles["exp-session-title"]}>You will be logged out soon</p>
      <p className={styles["exp-session-description"]}>
        To ensure data security, we will log you out automatically when the
        timer below ends.
      </p>
      {!!timeLeft && (
        <p className={styles["exp-session-counter"]}>{formatTime(timeLeft)}</p>
      )}
    </div>
  );
};

export default ExpiryContent;
